import { render, staticRenderFns } from "./Config.subject.page.vue?vue&type=template&id=e09db220&"
import script from "./Config.subject.page.vue?vue&type=script&lang=js&"
export * from "./Config.subject.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports